import React from 'react';
import { Button } from '../../flayr-components/Button/Button';
import { Flex } from '../../flayr-components/Flex/Flex';
import { Modal } from '../../flayr-components/Modal/Modal';
import ErrorMsg from '../ErrrorMsg/ErrorMsg';

interface IErrorModalProps {
  open?: boolean;
  title?: string;
  onClose?: (e?: any) => void;
  message?: React.ReactNode;
  errorMsgClassName?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const ErrorModal: React.FC<React.PropsWithChildren<IErrorModalProps>> = ({
  open,
  onClose,
  message,
  title,
  size = 'xs',
  errorMsgClassName,
}) => {
  return (
    <Modal title={title} open={open} onClose={onClose} size={size}>
      <Flex column center className="pt-1 text-center">
        <ErrorMsg message={message} className={errorMsgClassName} />
        <Button
          className="mt-5"
          size="lg"
          color="danger"
          onClick={onClose}
          block
        >
          Close
        </Button>
      </Flex>
    </Modal>
  );
};
export default ErrorModal;
